// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1f-7";
export var adjustableWidthBorderHeld = "_1f-8";
export var arrow = "_1f-3";
export var arrowButton = "_1f-4";
export var headerCell = "_1f-0";
export var help = "_1f-2";
export var icon = "_1f-1";
export var iconWrapper = "_1f-6";
export var noBorder = "_1f-b";
export var nonAdjustableWidthBorder = "_1f-9";
export var nonAdjustableWidthBorderHeld = "_1f-a";
export var textButton = "_1f-5";